import account from './account';
import apostille from './apostille';
import chain from './chain';
import endpoint from './endpoint';
import market from './market';
import mosaic from './mosaic';
import namespace from './namespace';
import supernodes from './supernodes';
import transaction from './transaction';

export default {
	account: account,
	apostille: apostille,
	chain: chain,
	endpoint: endpoint,
	market: market,
	mosaic: mosaic,
	namespace: namespace,
	supernodes: supernodes,
	transaction: transaction
}